import React from 'react'
import { observer } from 'mobx-react-lite'

import { useStore } from '../../hooks/storeHook'
import { useAccountParams } from '../../hooks/routeHooks'

import { OzonImportPage } from './Ozon/OzonImportPage'
import { WildberriesImportPage } from './Wildberries/WildberriesImportPage'
import { YandexMarketImportPage } from './YandexMarket/YandexMarketImportPage'

import { IntegrationType } from '../../server/mpsklad_core/Entity/IntegrationType'

export const ImportRoute =
  observer(() => {
    const {integration} = useAccountParams()

    const {allowedIntegrations} = useStore()

    if (!allowedIntegrations[integration]) {
      return null
    }

    return (
      <div className="body_wrapper_zero">
        {
          integration === IntegrationType.Ozon &&
          <OzonImportPage/>
        }

        {
          integration === IntegrationType.Wildberries &&
          <WildberriesImportPage/>
        }

        {
          integration === IntegrationType.YandexMarket &&
          <YandexMarketImportPage/>
        }
      </div>
    )
  })